import { PathItem } from "../types/PathItem";

export const getPathItem = (path: string): PathItem => {
  const pathItem: PathItem = {
    folder: path.substring(0, path.lastIndexOf("\\")),
    fileName: path.substring(path.lastIndexOf("\\") + 1),
  };

  return pathItem;
};

export const verifyExtension = (path: string, extension: string): string => {
  let fileName: string = path;
  if (fileName.lastIndexOf(".") === -1) {
    fileName = `${fileName}.${extension}`;
  }
  return fileName;
};

export const replaceExtension = (path: string, extension: string): string => {
  let fileName: string = path;
  const dotIndex = fileName.lastIndexOf(".");
  if (dotIndex === -1) {
    fileName = `${fileName}.${extension}`;
  } else {
    fileName = `${fileName.substring(0, dotIndex)}.${extension}`;
  }
  return fileName;
};
